module.exports = __webpack_public_path__ + "img/default-recipe.76fb65ae.jpg";